import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { InfoDialogComponent } from '../../dialogs/info-dialog/info-dialog.component';
import { AuthService } from '../../services/auth.service';
import { OfficeService } from '../../services/office.service';

@Component({
  selector: 'app-navigation',
  standalone: true,
  imports: [MatIconModule, MatButtonModule],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss',
})
export class NavigationComponent {
  public officeService: OfficeService = inject(OfficeService);
  public authService: AuthService = inject(AuthService);
  private router: Router = inject(Router);

  constructor(public dialog: MatDialog) {}
  navigateHome() {
    this.router.navigate(['patients']);
  }
  editUser() {
    this.router.navigate(['editUser']);
  }
  releaseNotes() {
    const dialogRef = this.dialog.open(InfoDialogComponent, {
      data: {
        title: 'Updates',
        description: `
            <strong>September 2024</strong>
            <p>Neue sachen 2</p>
            <br>
            <strong>August 2024</strong>
            <p>Neue sachen 1</p>
        `,
      },
    });
  }
  logout() {
    this.authService.logout();
    this.router.navigate(['auth']);
  }
}
